// Smile fixes the body on iPhone without a scrollY offset, which jumps the page
// to the top. Compensate while the lock class is present and restore on release.
const SMILE_IOS_SCROLL_LOCK = 'smile-ios-overflow-scroll';

const html = document.documentElement;
const body = document.body;
let lastY = window.scrollY;
let savedY = 0;
let locked = false;

function remember() {
  if (!html.classList.contains(SMILE_IOS_SCROLL_LOCK)) lastY = window.scrollY;
}

function sync() {
  const next = html.classList.contains(SMILE_IOS_SCROLL_LOCK);
  if (next === locked) return;
  if (next) {
    savedY = window.scrollY || lastY;
    body.style.top = `-${savedY}px`;
    locked = true;
    return;
  }
  body.style.top = '';
  locked = false;
  window.scrollTo(0, savedY);
}

new MutationObserver(sync).observe(html, { attributes: true, attributeFilter: ['class'] });
window.addEventListener('scroll', remember, { passive: true });
sync();
